export enum LocationType {

     HoldingCompany = 1,
     Organization = 2,
     Region = 3, 
     Area = 4,
     Branch = 5,
     Department=6
    
}